module.exports = __webpack_public_path__ + "static/media/french-flag.1545c448.svg";